import { render, staticRenderFns } from "./Observacoes.vue?vue&type=template&id=d142ca2c&scoped=true"
import script from "./Observacoes.vue?vue&type=script&lang=js"
export * from "./Observacoes.vue?vue&type=script&lang=js"
import style0 from "./Observacoes.vue?vue&type=style&index=0&id=d142ca2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d142ca2c",
  null
  
)

export default component.exports